import { Injectable } from '@angular/core';
import { BookingsSchedulersHttpService } from './booking-schedulers.http';
import { lastValueFrom } from 'rxjs';
import { IBookingScheduler } from 'src/app/models';
import { objectToCamel } from 'ts-case-convert';
import { initialPaginationState } from 'src/app/store/initialisation/pagination';

@Injectable({
  providedIn: 'root'
})
export class BookingSchedulersService {

  constructor(
      private bookingsSchedulersHttpService: BookingsSchedulersHttpService,
    ) {}
  
  async getBookingSchedulersById(bookingSchedulerId: number) { // TODO: bookingSchedulerId or bookingId
    const source$ = this.bookingsSchedulersHttpService.getBookingSchedulersById(bookingSchedulerId);
    const scheduler = await lastValueFrom(source$) as IBookingScheduler;
    return objectToCamel(scheduler);
  }

  async getBookingSchedulersByFavourite(favouriteId: number) {
    const source$ = this.bookingsSchedulersHttpService.getBookingSchedulersByFavourite(favouriteId);
    const schedulers = await lastValueFrom(source$);
    return schedulers;
  }

  async getBookingSchedulersByUserId(userId: number, page: number, size?: number) {
    const source$ = this.bookingsSchedulersHttpService.getBookingSchedulersByUserId(userId, page, size);
    const response = await lastValueFrom(source$);
    const recurrents = objectToCamel(response as object);
    const recurrentsArray = this.getDataWithPagination(recurrents, page);
    return recurrentsArray;
  }

  async createBookingScheduler(bookingScheduler: IBookingScheduler) {
    const source$ = this.bookingsSchedulersHttpService.createBookingScheduler(bookingScheduler);
    const response = await lastValueFrom(source$);
    const bookingSchedulerCreated = objectToCamel(response as object);
    return bookingSchedulerCreated;
  }

  async updateBookingScheduler(bookingScheduler: IBookingScheduler) {
    const source$ = this.bookingsSchedulersHttpService.updateBookingScheduler(bookingScheduler);
    const response = await lastValueFrom(source$);
    const bookingSchedulerUpdated = objectToCamel(response as object);
    return bookingSchedulerUpdated;
  }

  async deleteBookingScheduler(bookingSchedulerId: number) {
    const source$ = this.bookingsSchedulersHttpService.deleteBookingScheduler(bookingSchedulerId);
    const response = await lastValueFrom(source$);
    const bookingSchedulerDeleted = objectToCamel(response as object);
    return bookingSchedulerDeleted;
  }

  getDataWithPagination(response: any, page: number) {
    return {
      value: response.content,
      pagination: {
        ...initialPaginationState,
        numberOfElements: response.numberOfElements,
        totalPages: response.totalPages,
        totalElements: response.totalElements,
        first: response.first,
        last: response.last,
        actualPage: page,
        size: response.size
      }
    };
  }
}
